import {
  Component,
  ViewEncapsulation,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AnalyticsService,
  CustomerService,
  StorageService
} from '../../../../_services/index';
import {
  DataService,
  OptionsserviceService,
  LoansService,
  OperationsService
} from '../../../../_services/index';
import { IonRangeSliderComponent } from 'ng2-ion-range-slider';
import { HttpClient } from '@angular/common/http';
import {Location} from '@angular/common';

@Component({
  selector: 'app-analyticssocialdata',
  templateUrl: './analyticssocialdata.component.html',
  styleUrls: ['./analyticssocialdata.component.css']
})
export class AnalyticssocialdataComponent implements OnInit {
  view: any = 'data';
  text = 'Social Analytics';
  @Input('details') details: any;
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;
  @Input('token') token: any;
  @Input('parentRouteId') parentRouteId: any;
  @Input('loan') loan: any;
  selected_analytics = '1';
  nodesandscores: any;
  analytics_result: any;
  sub: any;
  currentUser: any;
  data: any;
  average_monthly_cost = 0;
  average_calls_per_month = 0;
  snapshot: any;
  full_analytics: any;
  social_analytics: any;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  linked_in_passed_arr: any;
  fb_passed_arr: any;
  twitter_passed_arr: any;
  linkedin_failed_arr: any;
  fb_failed_arr: any;
  twitter_failed_arr: any;
  sms_value: any;
  guarantor_value: any;
  call_logs_value: any;
  cards_value: any;
  profile_value: any;
  social_value: any = '1';
  accounts_value: any;
  dd_value: any;
  repayment_value: any;
  params: any = JSON.parse(localStorage.getItem('params'));
 social_status: any;
  bvn_value: any;
  social_passed: any;
  social_failed: any;
  analytics: any;
  analytics_score: any;
  loading: boolean;
  nodes_and_scores: any;
  analytics_last_done: any;
  linkedin_arr: any;
 facebook_arr: any;
 twitter_arr: any;
 social_highlights: any;
  constructor(
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    public analyticsService: AnalyticsService,
    private http: HttpClient,
    public router: Router,
    private _location: Location
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  dataView() {
    this.view = 'data';
  }

  analyticsView() {
    this.view = 'analytics';
  }
  saveAnalytics(event) {
    this.loansService.saveSMSAnalysisData(this.currentUser.token, this.parentRouteId, this.nodes_and_scores, this.data)
      .subscribe(data => {
        this.data = data.result;
        this.details = data.result;
        this.nodes_and_scores = data.nodes_and_scores;
        this.analytics_last_done = data.analytics_last_done;
        this.loan = data.loan;
      });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({
      section: section,
      request_id: this.parentRouteId
    });
  }
  ngOnInit() {
    this.getSummary();
    this.getAnalyticsData();
  }
  getAnalyticsData() {
    this.loading = true;
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.loansService
        .getSocialAnalyticsData( this.currentUser.token, this.parentRouteId)
        .subscribe(data => {
          this.loading = false;
          this.loan = data.loan;
          this.analytics = data.loan.analytics_summary.description.social_;
          this.social_status = data.loan.analytics_summary.status.social;
          this.social_passed = data.loan.analytics_summary.counts.social_passed;
          this.social_failed = data.loan.analytics_summary.counts.social_failed;
          this.analytics_score = data.loan.analytics_summary.final_analytics_score;
          this.social_highlights = data.loan.analytics_summary.output.social.social_data;
          this.linkedin_arr = this.analytics.filter(el => {
                      return el.status === 'failed';
                    }).filter(el => {
                      return el.display.startsWith('LinkedIn');
                    });
                   this.facebook_arr = this.analytics.filter(el => {
                      return el.status === 'failed';
                    }).filter(el => {
                      return el.display.startsWith('Facebook');
                    });
                   this.twitter_arr = this.analytics.filter(el => {
                        return el.status === 'failed';
                      }).filter(el => {
                        return el.display.startsWith('Twitter');
              });
          // this.linked_in_passed_arr = data.loan.analytics_summary.description.social.passed.map((el, i) => {
          //   if (el.indexOf('linkedin') > -1) {
          //     return el;
          //   }
          // }).filter(el => {
          //   return el !== undefined;
          // });
          // this.fb_passed_arr = data.loan.analytics_summary.description.social.passed.map((el, i) => {
          //   if (el.indexOf('facebook') > -1) {
          //     return el;
          //   }
          // }).filter(el => {
          //   return el !== undefined;
          // });
          // this.twitter_passed_arr = data.loan.analytics_summary.description.social.passed.map((el, i) => {
          //   if (el.indexOf('twitter') > -1) {
          //     return el;
          //   }
          // }).filter(el => {
          //   return el !== undefined;
          // });
          // this.linkedin_failed_arr = data.loan.analytics_summary.description.social.failed.map((el, i) => {
          //   if (el.indexOf('linkedin') > -1) {
          //     return el;
          //   }
          // }).filter(el => {
          //   return el !== undefined;
          // });
          // this.fb_failed_arr = data.loan.analytics_summary.description.social.failed.map((el, i) => {
          //   if (el.indexOf('facebook') > -1) {
          //     return el;
          //   }
          // }).filter(el => {
          //   return el !== undefined;
          // });
          // this.twitter_failed_arr = data.loan.analytics_summary.description.social.failed.map((el, i) => {
          //   if (el.indexOf('twitter') > -1) {
          //     return el;
          //   }
          // }).filter(el => {
          //   return el !== undefined;
          // });

        });
    });
  }
  getSummary() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.getLoan();
    });
  }
  getCusomer(people_id) {
    this.loansService
      .getLoanContractCustomer(this.currentUser.token, people_id)
      .subscribe(data => {
        this.details = data.data;
      });
  }
  getLoan() {
    this.loansService
      .getLoanContract(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.loan = data.loan;
        this.dataService.onRequestLoadingEndFromBackend.emit();
        this.getCusomer(data.loan.people_id);
      });
  }
  getAnalytics() {
    return new Promise((resolve, reject) => {
      return this.http
        .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
          request_id: '13126'
        })
        .toPromise()
        .then(res => {
          this.lender_id = res.lender_id;
          this.borrower_id = res.borrower_id;
          this.principal = res.principal;
          this.maturity_date = res.maturity_date;
          this.account_card_id = res.account_card_id;
          this.loan_request_id = res.loan_request_id;
          this.card_id = res.card_id;
          resolve();
        })
        .then(res => {
          this.getFullAnalytics();
        })
        .catch(err => {
          reject();
        });
    });
  }
  goBack() {
    this._location.back();
  }
  modifyAnalytics() {
    this.dataService.onEditApplicationsModal.emit({ section: 'specific_analytics', request_id: this.parentRouteId, nodes_and_scores: this.nodes_and_scores, selected_analytics: '2', analytics_last_done: this.analytics_last_done, isedit: '1' });
  }
  getFullAnalytics() {
  }
  // getSocialAnalytics() {
  //   return this.http.post<any>(`${this.constant.read('api_loan')}customer/getcustomer`, {
  //     token: this.token,
  //     people_id: this.people_id
  //   }).subscribe(res => {
  //     //console.log(res);
  //     if (res.status) {
  //       this.details = res.data;
  //     }
  //   }, err => {
  //     //console.log(err);
  //   })
  // }
}
